import { FC } from 'react';
import clsx from 'clsx';
import type { Comment } from 'app/modules/comments/types';
import CommentsListItemHeader from 'app/modules/posts/modules/post/components/postCommunication/comments/commentsList/CommentsListItemHeader';
import CommentsHyperText from 'app/modules/posts/modules/post/components/postCommunication/comments/commentsList/CommentsHyperText';
import CommentDeleted from 'app/modules/posts/modules/post/components/postCommunication/comments/CommentDeleted';

const GUEST_USER = { role: '' as const };

export const PUBLIC_COMMENT_BUBBLE_CLASS =
  'tw-w-fit tw-max-w-[85%] tw-whitespace-pre-wrap tw-break-words tw-rounded-xl tw-px-5 tw-py-3 tw-text-md tw-text-grayscale-180';

interface PublicCommentBubbleProps {
  comment: Comment;
}

export const PublicCommentBubble: FC<PublicCommentBubbleProps> = ({
  comment,
}) => {
  const isSharer = comment.user?.its_me ?? false;

  return (
    <div
      className={clsx('tw-flex tw-flex-col tw-gap-1', {
        'tw-items-end': isSharer,
        'tw-items-start': !isSharer,
      })}
      data-cy="public-comment-bubble"
      data-testid="public-comment-bubble"
    >
      <CommentsListItemHeader comment={comment} currentUser={GUEST_USER} />
      <div
        className={clsx(PUBLIC_COMMENT_BUBBLE_CLASS, {
          'tw-bg-white': isSharer,
          'tw-bg-accent-100': !isSharer,
        })}
      >
        {comment.deleted_at ? (
          <CommentDeleted isAuthor={isSharer} colorVariant="primary" />
        ) : (
          <CommentsHyperText
            isCurrentUser={isSharer}
            colorVariant="primary"
            mentionedUsers={comment.mentioned_users ?? []}
          >
            {comment.content}
          </CommentsHyperText>
        )}
      </div>
    </div>
  );
};
